<template>
  <div>
    <ul class="mt-16 md:mt-0">
      <li
        v-for="sitterSkeleton in sitterSkeletonArray"
        :key="sitterSkeleton"
        class="w-full shadow-none sm:border-b-1 border-grey-divider-subdued border-solid rounded-none last:border-b-0 px-16 pb-16 sm:p-0"
      >
        <SitterCard :isLoading="true" :yearsExperience="0" :totalRatings="0" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import SitterCard from '@/components/sitter_card/SitterCard.vue';

export default {
  name: 'ApplicationsSkeleton',
  components: { SitterCard },
  computed: {
    sitterSkeletonArray(): number[] {
      // add skeletons based on user window height
      return Array(Math.floor(window.innerHeight / 225));
    },
  },
};
</script>

<style></style>
